require('../modules/web.immediate');
module.exports = require('../modules/_core').setImmediate;


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/node_modules/jszip/node_modules/core-js/library/fn/set-immediate.js
// module id = ../../../../jszip/node_modules/core-js/library/fn/set-immediate.js
// module chunks = vendor